// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__i5tf_","mainBar":"styles_mainBar__Bbst3","secondBar":"styles_secondBar__DWbWu","slideInSearchBar":"styles_slideInSearchBar__B8t1o"};